const useAuthenticatedMock = () => true;

export default useAuthenticatedMock;
